<tam-dialog class="exchange-check-dialog" tid="exchange_check_dialog" [opened]="isOpened" [dialogWidth]="dialogWidth"
    (keydown.esc)="onCancelBtnClick($event)">
    <ng-template #title>
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon class="dialog-close dark" name="close" (click)="onCancelBtnClick($event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer">
            <span>{{headerTip}}</span>
            <div class="exchange-check-list">
                <div class="exchange-check-header exchange-check-header-bac">
                    <label tam-checkbox class="exchange-checkbox" [(ngModel)]="isSelectAll"
                        (click)="onClickSelectAll(item)"></label>
                    <label class="exchange-type">Contact</label>
                    <label class="exchange-email">Email Address</label>
                </div>
                <div class="exchange-check-header exchange-check-content"
                    *ngFor="let item of exchangeList;let i = index;" (click)="onClickCheckItem(item)">
                    <label tam-checkbox class="exchange-checkbox" [(ngModel)]="item.select"></label>
                    <label class="exchange-type">{{item.exchange.name}}</label>
                    <label class="exchange-email">{{item.exchange.emailAddress}}</label>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button "
            (click)="onCancelBtnClick($event)">Cancel</button>
        <button tam-button tamType="primary" tamSize="normal" class="dialog-button import-button"
            (click)="clickNextButton($event)" [tamLoading]="isProgressing" [disabled]="isSelectOne()">Import</button>
    </ng-template>
</tam-dialog>